import { z } from 'zod';
import type { ApiSchemaClass, ApiSchemaDefinition } from './types';
import {
  cliAuthApproveResponseSchema,
  cliAuthPollTokenResponseSchema,
} from './common-responses';

export const cliAuthDeviceCodeBodyV20260601Schema = z.object({
  device_code: z.string(),
});

export type CliAuthDeviceCodeBody = z.infer<
  typeof cliAuthDeviceCodeBodyV20260601Schema
>;

export class CliAuthPollTokenV20260601Schema implements ApiSchemaDefinition {
  static readonly version = 'cli-auth-poll-token-2026-06-01' as const;

  readonly name = CliAuthPollTokenV20260601Schema.version;
  readonly schema = cliAuthDeviceCodeBodyV20260601Schema;
  readonly response = cliAuthPollTokenResponseSchema;
}

export class CliAuthApproveV20260601Schema implements ApiSchemaDefinition {
  static readonly version = 'cli-auth-approve-2026-06-01' as const;

  readonly name = CliAuthApproveV20260601Schema.version;
  readonly schema = cliAuthDeviceCodeBodyV20260601Schema;
  readonly response = cliAuthApproveResponseSchema;
}

export const CLI_AUTH_API_SCHEMAS = [
  CliAuthPollTokenV20260601Schema,
  CliAuthApproveV20260601Schema,
] as const satisfies readonly ApiSchemaClass[];
